import React from 'react';
import ResponsiveImageSet from '../UI/ResponsiveImageSet/ResponsiveImageSet';
import styles from './HeroLeadGraphic.module.scss';

const HeroLeadGraphic = ({ leadGraphicConfig }) => {
    if (!leadGraphicConfig?.hasLeadGraphic) return null;
    if (leadGraphicConfig.breakpoints && leadGraphicConfig.breakpoints.length > 0) {
        return (
            <div className={styles.subtitleGraphic}>
                <ResponsiveImageSet
                    breakpoints={leadGraphicConfig.breakpoints}
                    altText={leadGraphicConfig.altText || ''}
                />
            </div>
        );
    }
    return null;
};

export default HeroLeadGraphic;
